export const isNull = (o) => {
  return o === null || o === "" || o === undefined
}
export const isObj = (o) => {
  // 是否对象
  return Object.prototype.toString.call(o).slice(8, -1) === "Object"
}
export const isObjNull = (o) => {
  if (o === (null || undefined)) return false
  return Object.keys(o).length === 0
}
export const isArray = (o) => {
  // 是否数组
  return Object.prototype.toString.call(o) === "[object Array]"
}
export const isFunction = (o) => {
  // 是否函数
  return Object.prototype.toString.call(o).slice(8, -1) === "Function"
}
export const isString = (o) => {
  // 是否字符串
  return Object.prototype.toString.call(o).slice(8, -1) === "String"
}
export const isFile = (o) => {
  // 是否文件
  return Object.prototype.toString.call(o).slice(8, -1) === "File"
}
export const isNumber = (o) => {
  return Object.prototype.toString.call(o).slice(8, -1) === "Number"
}
export const isArrNull = (o) => {
  return o.length === 0
}

// 获取路由的参数
export const getQueryUrl = (name) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r= window.location.hash.substr(1)
  let result = null
  if(r.indexOf('?') > 0 ) result = r.split('?')[1]
  if(result == null) return null
  let rs = result.match(reg)
  if (rs != null) return unescape(rs[2]);
  return null;
}

const basicsTools = {
  isArray,
  isArrNull,
  isFile,
  isFunction,
  isNull,
  isNumber,
  isObj,
  isObjNull,
  isString,
  getQueryUrl
}
basicsTools.install = function (Vue) {
  Vue.prototype.$basicsTools = basicsTools
}
export default basicsTools
